import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getColors } from './tokens';
const STORAGE_KEY = 'wp-theme';
const ThemeContext = createContext(null);
function getSystemPreference() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
function getSavedTheme() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark')
        return true;
    if (saved === 'light')
        return false;
    return null;
}
function applyTheme(dark) {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
}
export function ThemeProvider({ children }) {
    const [isDark, setIsDark] = useState(() => {
        const saved = getSavedTheme();
        return saved ?? getSystemPreference();
    });
    useEffect(() => {
        applyTheme(isDark);
    }, [isDark]);
    // Listen for OS-level changes when no saved preference
    useEffect(() => {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => {
            if (getSavedTheme() === null) {
                setIsDark(e.matches);
            }
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);
    const toggle = useCallback(() => {
        setIsDark(prev => {
            const next = !prev;
            localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light');
            return next;
        });
    }, []);
    const value = {
        isDark,
        toggle,
        colors: getColors(isDark),
    };
    return _jsx(ThemeContext.Provider, { value: value, children: children });
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme must be used within a ThemeProvider');
    return ctx;
}
